import * as _ from 'lodash'
import { getTemplateByApp } from 'templates/templates'
import { setCustomFieldArray } from './logic'

export function assetRemoved (asset) {
  return function * (dispatch, getState) {
    const apps = getState().apps
    for (const appId in apps) {
      const app = apps[appId]
      try {
        const template = getTemplateByApp(app)
        const paths = asset.type === 'video' ? template.videoPaths : template.imagePaths
        if (paths && paths.length > 0) {
          for (const path of paths) {
            const currentValue = _.get(app.customFields, path)
            if (currentValue && (currentValue === asset.url || currentValue.url === asset.url)) {
              dispatch(setCustomFieldArray(appId, path, null))
            }
          }
        }
      } catch (e) {
        console.log('assetRemoved error', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/assets.js